import toast from "react-hot-toast";
import * as api from "../Api/index";
import io from "socket.io-client";
const socket = io();
export const getClaim = () => async (dispatch) => {
  try {
    const { data } = await api.getClaim();
    dispatch({ type: "GET_ALL_CLAIMS", payload: data });
  } catch (error) {
    toast.error(error.message);
  }
};

export const createClaim = (postData) => async (dispatch) => {
  let submittingId;
  try {
    submittingId = toast.loading("Submitting Claim....");
    const { data } = await api.createClaim(postData);
    dispatch({ type: "CREATE_CLAIM", payload: data });
    toast.remove(submittingId);
    toast.success("Claim successfully submitted");
    socket.emit("submitClaim", {});
  } catch (error) {
    toast.remove(submittingId);
    toast.error(error.message);
  }
};

export const updateBranchClaim = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    await api.approveBranchClaim(id, postData);
    dispatch({ type: "APPROVE_BRANCH_CLAIM", payload: id });
    toast.remove(updatingId);
    toast.success("Changes saved successfully");
    socket.emit("submitClaim", {});
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};

export const deleteClaim = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting claim....");
    await api.deleteClaim(id);
    dispatch({ type: "DELETE_BRANCH_CLAIM", payload: id });
    toast.remove(deletingId);
    toast.dismiss();
    toast.success("Successfully deleted");
    socket.emit("submitClaim", {});
  } catch (error) {
    toast.remove(deletingId);
    toast.dismiss();
    toast.error(error.message);
  }
};

export const clearClaim = (id, postData) => async (dispatch) => {
  let clearingId;
  try {
    clearingId = toast.loading("Clearing claim...");
    await api.clearClaim(id, postData);
    dispatch({ type: "CLEAR_CLAIM", payload: id });
    toast.remove(clearingId);
    toast.success("Successfully cleared");
    socket.emit("submitClaim", {});
  } catch (error) {
    toast.remove(clearingId);
    toast.error(error.message);
  }
};
